import type { ApiBaseResponse } from '@module/apis/type';
import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type {
  BJProfileFieldData,
  FetchGlobalServiceProfileParams,
  FetchGlobalServiceProfileResponse,
  FetchGlobalServiceProfileTranslateResponse,
} from './type';

export const fetchGlobalServiceProfile = async (
  params: FetchGlobalServiceProfileParams,
): Promise<FetchGlobalServiceProfileResponse> => {
  const res = await fetchExtended(`/v1/channel/get_profile`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchGlobalServiceProfileResponse;
};

export const fetchGlobalServiceProfileUpdate = async (params: BJProfileFieldData): Promise<ApiBaseResponse> => {
  const res = await fetchExtended(`/v1/channel/edit_profile`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as ApiBaseResponse;
};

// 금칙어 검사 & 번역
export const fetchGlobalServiceProfileTranslate = async (
  params: BJProfileFieldData,
): Promise<FetchGlobalServiceProfileTranslateResponse> => {
  const res = await fetchExtended(`/v1/channel/check_profile`, {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(params),
  });

  const result = await res.json();

  return result as FetchGlobalServiceProfileTranslateResponse;
};
